/**
 * Skills Toggle Module
 * Handles showing/hiding skills sections in job cards
 */
export default function initSkillsToggle() {
    // Handle skills toggle clicks
    $(document).on('click', 'a[href="#view-skills"]', function(e) {
        e.preventDefault();
        
        // Find the closest job-card and toggle the skills-wrap
        var $jobCard = $(this).closest('.job-card');
        var $skillsWrap = $jobCard.find('.job-card__skills-wrap');
        var $link = $(this);
        
        // Toggle the show class and animate
        if ($skillsWrap.hasClass('show')) {
            $skillsWrap.removeClass('show').slideUp(300);
            $link.text('View Skills');
            $link.removeClass('open');
        } else {
            $skillsWrap.addClass('show').slideDown(300);
            $link.text('Hide Skills');
            $link.addClass('open');
        }
    });
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    initSkillsToggle();
});
